<template>
    <b-form-invalid-feedback :id="`one-page-horizon-${onePageHorizon.index.$model}`" :state="state">
        <div v-if="showDescriptionRequiredValidation">
            {{ $t('strategy.onepage.horizons.validations.description') }}
        </div>
        <div v-if="showDateStartRequiredValidation">
            {{ $t('strategy.onepage.horizons.validations.date.initial') }}
        </div>
        <div v-if="showDateEndRequiredValidation">
            {{ $t('strategy.onepage.horizons.validations.date.end') }}
        </div>
        <div v-if="showMustBeAfterStartDateValidation">
            {{ $t('strategy.onepage.horizons.validations.date.endUpperInitial') }}
        </div>
    </b-form-invalid-feedback>
</template>
<script>
export default {
    props: {
        onePage: {
            type: Object,
            required: true,
        },
        onePageHorizon: {
            type: Object,
            required: true,
        },
        state: {
            type: Boolean | null,
            required: true,
        },
    },
    computed: {
        showDescriptionRequiredValidation() {
            return !this.onePageHorizon.description.required
        },
        showDateStartRequiredValidation() {
            return !this.onePageHorizon.date_start.required
        },
        showDateEndRequiredValidation() {
            return !this.onePageHorizon.date_end.required
        },
        showMustBeAfterStartDateValidation() {
            return !this.onePageHorizon.date_end.mustBeAfterStartDate
        },
        showOnePagePeriodValidation() {
            return (
                !this.onePageHorizon.date_start.maxDate ||
                !this.onePageHorizon.date_end.maxDate ||
                !this.onePageHorizon.date_start.minDate ||
                !this.onePageHorizon.date_end.minDate
            )
        },
    },
}
</script>
